import { render, staticRenderFns } from "./dilu-button.vue?vue&type=template&id=38e0dde6&scoped=true&"
import script from "./dilu-button.vue?vue&type=script&lang=js&"
export * from "./dilu-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0dde6",
  null
  
)

export default component.exports